import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';
import type {EmailMakerSaveErrorPanelProps} from '@Components/panels/email-maker-save-error-panel/email-maker-save-error-panel.types';

const PANEL_ID = 'email-maker-save-error-panel';

export type EmailMakerSaveErrorModalProps = EmailMakerSaveErrorPanelProps;

export default function EmailMakerSaveErrorModal(): ReactElement {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.EMAIL_MAKER_SAVE_ERROR_MODAL];
  });

  return (
    <Modal
      modalId={MODALS_IDS.EMAIL_MAKER_SAVE_ERROR_MODAL}
      showNonFunctionalDragHandle
      modalMaxHeight="fit-content"
      modalHeight="fit-content"
      modalMaxWidth="500px"
      panelId={PANEL_ID}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="email-maker-save-error-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const openEmailMakerSaveErrorModal = (props: EmailMakerSaveErrorModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EMAIL_MAKER_SAVE_ERROR_MODAL,
      panelProps: props,
    })
  );
};
